'use client';
var classes = {"card":"m_9dc8ae12"};

export { classes as default };
//# sourceMappingURL=RadioCard.module.css.mjs.map
